import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { global } from "@shared/libs/Global";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import SearchPanel from "@widgets/SearchPanel";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { showDialog } from "@widgets/CommonDialog";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";

interface popupProps {
  modalRef?: any;
  selectedData?: any;
}

const SN_MAS_BAS_REG_001_POP_001 = forwardRef(
  ({ modalRef, selectedData }: popupProps, ref: React.Ref<any>) => {
    const { userInfo } = global();

    const searchRef = useRef<any>(null);
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
    });

    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns, setColums] = useState<any>({
      grid1: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
    });

    const [popupParent, setPopupParent] = useState<any>(null);

    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        return await onSave();
      },
      getOkayData: async () => {
        return {
          closeFlag: true,
          rtnData: [],
        };
      },
    }));

    useEffect(() => {
      if (modalRef?.current) {
        setPopupParent(modalRef.current.getPopupParent());
      }
    }, [modalRef?.current]);

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_MAS_BAS_REG_001_POP_001",
            {}
          );
          const mergedData: any = {
            ...rtn.formData,
            ...selectedData,
            fg_cust: "5",
          };
          setFormControlData(rtn.formControlData);
          setFormData(mergedData);
          setColums({
            grid1: rtn.grid.grid1,
          });
          onSearch(mergedData);
        } catch (error) {}
      };
      fetchform();
    }, []);

    const onSearch = async (mergedData: any) => {
      try {
        const param = {
          id: "sn_mas_bas_reg_001_pop_001_01",
          params: mergedData,
        };

        const data: any = await fnGetDataSet(param);
        setDataSources({
          grid1: data[0] || [],
        });
        gridRefs.current["grid1"].current.resetUpdate();
      } catch (error: any) {}
    };

    const onSave = async () => {
      try {
        gridRefs.current["grid1"].current.stopEditing();

        const requiredValuesCheckH =
          gridRefs.current["grid1"].current.requiredValuesCheck();
        if (!requiredValuesCheckH) return false;

        const custDepositChanges =
          gridRefs.current["grid1"].current.getChange();
        if (custDepositChanges.modifiedRowcount === 0) {
          await showDialog("alter", "변경된 내용이 없습니다.");
          return false;
        }

        const saveData = {
          custDeposit: custDepositChanges,
        };
        const ok = await fnSave(
          "SN_MAS_BAS_REG_001_POP_DEPOSIT_SAVE_01",
          saveData
        );
        if (!ok) return false;

        gridRefs.current["grid1"].current.resetUpdate();
        return true;
      } catch (error: any) {
        gridRefs.current["grid1"].current.resetUpdate(true);
        return false;
      }
    };

    const onAddRow = async () => {
      try {
        return gridRefs.current["grid1"].current?.addRow({
          cd_firm: userInfo.cd_firm,
          cd_cust_owner: selectedData?.cd_cust,
          nm_owner: selectedData?.nm_biz,
          fg_cust: formData.fg_cust,
          yn_use: "Y",
        });
      } catch (error: any) {}
    };

    const onDeleteRow = async () => {
      if (gridRefs.current["grid1"].current?.getDisplayedRowCount() < 1) return;
      gridRefs.current["grid1"].current.deleteSelectedRows();
    };

    const onGrid1BtnsClick = async (id: string) => {
      if (id == "addRow") {
        onAddRow();
      }
      if (id == "deleteRow") {
        onDeleteRow();
      }
    };

    const validateStdAccount = async () => {
      let checkedCount = 0;

      gridRefs.current["grid1"].current?.forEachNode((node: any) => {
        const ynStd = node?.data?.yn_std;
        if (ynStd === true || ynStd === "Y") {
          checkedCount += 1;
        }
      });

      if (checkedCount > 1) {
        await showDialog("alter", "대표 계좌는 1개만 지정되어야 합니다.");
        return false;
      }

      return true;
    };

    const onCellValueChanged = async (event: any) => {
      const rowNode = event.rowNode;
      if (!event || event.colId !== "yn_std") return;

      const isValid = await validateStdAccount();
      if (!isValid) {
        rowNode.setDataValue("yn_std", "N");
        return;
      }
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onBtnAddClick: onGrid1BtnsClick,
            onBtnDeleteClick: onGrid1BtnsClick,
            onCellValueChanged: onCellValueChanged,
          },
        },
      }),
      [columns, dataSources]
    );

    return (
      <div className="h-full flex flex-col">
        <div className="mb-2">
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>

        <div className="flex-1 flex flex-col gap-2 min-h-00">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{
              title: "계좌정보",
              rowSelection: "single",
              popupParent: popupParent,
              isEditable: true,
            }}
            events={grids.grid1.events}
          />
        </div>
      </div>
    );
  }
);

export default SN_MAS_BAS_REG_001_POP_001;
